export default "__VITE_ASSET__DC3kUBry__"